module.exports = __webpack_public_path__ + "img/user-6.a8406df3.svg";